"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _text = _interopRequireDefault(require("@ux/text"));
/**
 * ExpressCartLoader Component
 *
 * @param {Object} props React props
 * @param {React.ElementType} props.SkeletonContainer styled container component
 * @param {React.ElementType} props.MessageContainer styled message container component
 * @param {React.ElementType} props.Bars styled wrapper component
 * @param {React.ElementType} props.Container styled container component
 * @param {React.ElementType} props.Card styled card component
 * @param {React.ElementType} props.HeadRow styled head row component
 * @param {React.ElementType} props.Row styled row component
 * @param {React.ElementType} props.Button styled button component
 * @param {React.ElementType} props.SsoButtonWrapper styled SSO button wrapper
 * @param {React.ElementType} props.SsoButton styled SSO button component
 * @param {React.ElementType} props.Columns styled columns component
 * @returns {React.ReactElement} ExpressCartLoader Component
 */

function ExpressCartLoader({
  loadingMessage,
  SkeletonContainer,
  MessageContainer,
  Bars,
  Container,
  Card,
  HeadRow,
  Row,
  Button,
  SsoButtonWrapper,
  SsoButton,
  Columns
}) {
  return /*#__PURE__*/_react.default.createElement(SkeletonContainer, {
    "data-cy": "skeleton-loader"
  }, loadingMessage && /*#__PURE__*/_react.default.createElement(MessageContainer, null, /*#__PURE__*/_react.default.createElement(_text.default.p, {
    as: "title",
    size: 5,
    text: loadingMessage
  })), /*#__PURE__*/_react.default.createElement(Bars, null, /*#__PURE__*/_react.default.createElement(Container, null, /*#__PURE__*/_react.default.createElement(Card, {
    className: "left-card"
  }, /*#__PURE__*/_react.default.createElement(HeadRow, null), /*#__PURE__*/_react.default.createElement(Row, {
    style: {
      width: '60%'
    }
  }), /*#__PURE__*/_react.default.createElement(SsoButtonWrapper, null, /*#__PURE__*/_react.default.createElement(SsoButton, null), /*#__PURE__*/_react.default.createElement(SsoButton, null), /*#__PURE__*/_react.default.createElement(SsoButton, null)), /*#__PURE__*/_react.default.createElement(Row, null), /*#__PURE__*/_react.default.createElement(Row, {
    style: {
      width: '80%'
    }
  }), /*#__PURE__*/_react.default.createElement(Row, {
    style: {
      width: '60%'
    }
  })), /*#__PURE__*/_react.default.createElement(Button, null), /*#__PURE__*/_react.default.createElement(Button, null)), /*#__PURE__*/_react.default.createElement(Container, null, /*#__PURE__*/_react.default.createElement(Card, null, /*#__PURE__*/_react.default.createElement(HeadRow, null), /*#__PURE__*/_react.default.createElement(Row, {
    style: {
      width: '60%'
    }
  }), /*#__PURE__*/_react.default.createElement(Columns, null, /*#__PURE__*/_react.default.createElement(Row, {
    style: {
      width: '30%'
    }
  }), /*#__PURE__*/_react.default.createElement(Row, {
    style: {
      width: '20%'
    }
  })), /*#__PURE__*/_react.default.createElement(Columns, null, /*#__PURE__*/_react.default.createElement(Row, {
    style: {
      width: '40%'
    }
  }), /*#__PURE__*/_react.default.createElement(Row, {
    style: {
      width: '10%'
    }
  })), /*#__PURE__*/_react.default.createElement(Columns, null, /*#__PURE__*/_react.default.createElement(HeadRow, null), /*#__PURE__*/_react.default.createElement(Row, {
    style: {
      width: '15%'
    }
  })), /*#__PURE__*/_react.default.createElement(Button, null)))));
}
var _default = exports.default = ExpressCartLoader;
ExpressCartLoader.propTypes = {
  loadingMessage: _propTypes.default.string,
  SkeletonContainer: _propTypes.default.elementType,
  MessageContainer: _propTypes.default.elementType,
  Bars: _propTypes.default.elementType,
  Container: _propTypes.default.elementType,
  Card: _propTypes.default.elementType,
  HeadRow: _propTypes.default.elementType,
  Row: _propTypes.default.elementType,
  Button: _propTypes.default.elementType,
  SsoButtonWrapper: _propTypes.default.elementType,
  SsoButton: _propTypes.default.elementType,
  Columns: _propTypes.default.elementType
};